// 组件类
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
  RouterOutlet,
} from "@angular/router";
import { filter } from "rxjs/operators";
import { Subscription } from "rxjs";
import { RouteReuseStrategy } from "@angular/router";
import { CommonFunctionService } from "../../service/common-function.service";
import { DrawerService } from "../../service/drawer.service";
import { KeepAliveService } from "../../service/keep-alive.service";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { getTranslation } from "../../utils/utils";
@Component({
  selector: "rs-multi-tab",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"],
})
export class MultiTabComponent implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    public router: Router,
    public cf: CommonFunctionService,
    public activatedRoute: ActivatedRoute,
    private ref: ChangeDetectorRef,
    private drawer: DrawerService,
    private routeReuseStrategy: RouteReuseStrategy
  ) {
    this.keepAlive = this.routeReuseStrategy as KeepAliveService;
  }
  keepAlive: KeepAliveService;
  @Input() singleReuseUrls: string[] = []; //只能单个缓存的url
  @Input() noGenerateTabUrls: string[] = []; //不生成tab的url
  @Input() flattenMenu = [];
  @Input() defaultTabUrl = "";

  @Output() onRefreshTab = new EventEmitter();
  @Output() onCloseTab = new EventEmitter();

  private subscriptions: Subscription[] = [];
  TAB_WIDTH = 164;
  GAP_NORMAL = 54;
  GAP_SMALL = 30;
  textGap; // 文本与边框的总间距
  foo: RouterOutlet;
  comRef: any;
  tabList = [];
  selectedTab: number = 0;
  maxTabs: number = 10;
  screenWidth: number = window.innerWidth; // 初始化屏幕宽度
  translation;

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.screenWidth = window.innerWidth; // 更新屏幕宽度
    // this.setEllipsisTitle(); 在最外面容器调用
  }

  ngOnInit() {
    this.translation = getTranslation();

    this.initTab();
    // 解决刷新页面后，选中的 tab 丢失问题
    const isExistIdx = this.tabList.findIndex(
      (ele) =>
        this.urlWithoutQuery(ele.url) === this.urlWithoutQuery(this.router.url)
    );
    if (isExistIdx !== -1) {
      this.selectedTab = isExistIdx;
    }
    this.subscriptions.push(
      this.router.events
        .pipe(filter((event) => event instanceof NavigationStart))
        .subscribe((event: any) => {
          const navigation = this.router.getCurrentNavigation(); // 获取当前导航
          if (navigation) {
            const state = navigation.extras.state; // 获取传递的 state
            let noReused = (state && state["noReused"]) || false; // 当前tab不复用，新开一个tab,当有已经存在的tab时候也是新开

            const isExistIdx = this.tabList.findIndex(
              (ele) =>
                this.urlWithoutQuery(ele.url) ===
                this.urlWithoutQuery(event.url)
            );
            if (
              isExistIdx !== -1 &&
              (noReused || this.tabList[isExistIdx].url !== event.url)
            ) {
              // 如果当前tab已经存在，并且是新开的tab
              this.closeTab(isExistIdx, true); // 关闭当前tab
            }
          }
        })
    );
    this.subscriptions.push(
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe((event) => {
          const navigation = this.router.getCurrentNavigation(); // 获取当前导航
          if (navigation) {
            const tooltipElements = document.querySelectorAll(".e-popup-open");
            // 删除tooltips
            tooltipElements.forEach((element) => {
              const htmlElement = element as HTMLElement;
              htmlElement.style.display = "none";
            });
            const state = navigation.extras.state; // 获取传递的 state
            const skipLocationChange = navigation.extras.skipLocationChange; // 获取是否跳过 location change
            const currentRoute = this.router.routerState.root.firstChild;
            const navigationInfo = JSON.parse(
              sessionStorage.getItem("navigationInfo") || "{}"
            );
            let title =
              (state && state["title"]) ||
              navigationInfo.title ||
              navigationInfo.subTitle ||
              navigationInfo.name;

            if (currentRoute && !skipLocationChange) {
              if (
                this.noGenerateTabUrls.includes(
                  this.urlWithoutQuery(this.router.url)
                )
              ) {
                return; // 排除不生成tab的url
              }
              this.setTab(
                this.router.url,
                currentRoute.snapshot.routeConfig.path,
                title
              );
            }
          }
        })
    );
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.setEllipsisTitle();
    }, 50);
  }
  ngOnDestroy() {
    this.tabList = []; // 清空 tab 列表
    this.selectedTab = 0; // 重置选中的 tab 索引
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  setEllipsisTitle() {
    this.textGap = this.GAP_NORMAL;
    if (this.screenWidth <= 1100) {
      this.textGap = this.GAP_SMALL;
    }
    let { allWidth, leftWidth, rightWidth } = this.calcTabWidth();
    let width = Math.floor(
      (allWidth - rightWidth) / (this.tabList && this.tabList.length)
    );
    this.tabList.forEach((ele, idx) => {
      ele.displayTitle = this.cf.setMiddleEllipsis(
        this.translation[ele.title] || ele.title,
        width > this.TAB_WIDTH
          ? this.TAB_WIDTH - this.textGap
          : width - this.textGap,
        12
      );
    });
    this.ref.markForCheck();
    this.ref.detectChanges();
  }

  calcTabWidth() {
    const wrap = document.querySelector(".rs-multi-tab");
    const ulElement = document.querySelector(".rs-multi-tab > ul");
    const refreshTabDiv = document.querySelector(".rs-multi-tab .refresh-tab");
    let allWidth;
    let leftWidth;
    let rightWidth;
    if (wrap && ulElement) {
      // 获取元素的位置信息
      const wrapRect = wrap.getBoundingClientRect();
      const ulRect = ulElement.getBoundingClientRect();
      const refreshTabRect =
        refreshTabDiv && refreshTabDiv.getBoundingClientRect();
      allWidth = wrapRect.width;
      leftWidth = ulRect.width;
      rightWidth = (refreshTabRect && refreshTabRect.width) || 100;
    }
    return {
      allWidth,
      leftWidth,
      rightWidth,
    };
  }
  initTab() {
    // console.log("this.flattenMenu", this.flattenMenu);
    let TabCache = JSON.parse(sessionStorage.getItem("TabCache"));
    this.tabList = TabCache || [];
    if (this.tabList.length === 0) {
      const pureUrl = this.urlWithoutQuery(this.router.url);
      const target = this.flattenMenu.find((ele) => ele.url === pureUrl);
      if (target) {
        if (target.url !== this.defaultTabUrl) {
          const defaultTab = this.flattenMenu.find(
            (ele) => ele.url === this.defaultTabUrl
          );
          this.tabList.push({
            url: defaultTab.url,
            title: defaultTab.menuCode || defaultTab.label,
            displayTitle: defaultTab.menuCode || defaultTab.label,
          });
        }
        this.addTab(target.url, target.menuCode || target.label);
      }
    }
  }

  closeTab(idx, noChange?) {
    const tab = this.tabList[idx];
    this.tabList = this.tabList.filter((ele) => ele.url !== tab.url);
    this.clearCache(tab.url);
    if (!noChange && this.selectedTab === idx) {
      const targetIdx = Math.max(0, idx - 1);
      this.changeTab(this.tabList[targetIdx], targetIdx);
    }
    if (idx < this.selectedTab) {
      this.selectedTab = this.selectedTab - 1; // 如果关闭的tab在当前选中的tab之前，选中tab索引减1
    }
    this.setEllipsisTitle();
    sessionStorage.setItem("TabCache", JSON.stringify(this.tabList));
    this.onCloseTab.emit(tab);
    this.ref.markForCheck();
  }

  changeTab(tab, idx) {
    this.router.navigateByUrl(tab.url);
    if (tab.navigationInfo) {
      sessionStorage.setItem(
        "navigationInfo",
        JSON.stringify(tab.navigationInfo)
      );
    }
    if (tab.fromInfo) {
      sessionStorage.setItem("fromInfo", JSON.stringify(tab.fromInfo));
    }
    if (tab.permissions) {
      sessionStorage.setItem("permissions", JSON.stringify(tab.permissions));
    }
    this.selectedTab = idx;
    this.ref.markForCheck();
  }

  addTab(url, title) {
    if (this.tabList.length >= this.maxTabs) {
      const secondTab = this.tabList[1];
      this.tabList = this.tabList.filter((ele) => ele.url !== secondTab.url);
      this.clearCache(secondTab.url);
    }
    const localPermissions =
      sessionStorage.getItem("permissions") ||
      localStorage.getItem("permissions");
    const navigationInfo = JSON.parse(sessionStorage.getItem("navigationInfo"));
    const fromInfo = JSON.parse(sessionStorage.getItem("fromInfo"));
    const permissions = JSON.parse(localPermissions);

    this.tabList.push({
      url: url,
      title: title || "default",
      displayTitle: title,
      navigationInfo: navigationInfo,
      permissions: permissions,
      fromInfo: fromInfo,
    });
    this.selectedTab = this.tabList.length - 1;
    this.setEllipsisTitle();
    sessionStorage.setItem("TabCache", JSON.stringify(this.tabList));
    this.ref.markForCheck();
  }

  public setTab(url, pureUrl, title) {
    const isExistIdx = this.tabList.findIndex(
      (ele) => this.urlWithoutQuery(ele.url) === this.urlWithoutQuery(url)
    );
    if (isExistIdx === -1) {
      const singleIdx = this.singleReuseUrls.findIndex(
        (ele) => ele === pureUrl
      );
      if (singleIdx !== -1) {
        this.tabList = this.tabList.filter(
          (ele) => !ele.url.includes(this.singleReuseUrls[singleIdx])
        );
        this.keepAlive.clearCache(this.urlWithoutQuery(url));
        this.drawer.deleteCache(url);
      }
      this.addTab(url, title);
    } else {
      this.changeTab(this.tabList[isExistIdx], isExistIdx);
      this.ref.markForCheck();
    }
  }

  onTabDrop(event: CdkDragDrop<string[]>) {
    const { previousIndex, currentIndex } = event;
    // 禁止拖动第一个标签页
    if (previousIndex === 0 || currentIndex === 0) return;
    const wasSelected = this.selectedTab === previousIndex;
    moveItemInArray(this.tabList, previousIndex, currentIndex);
    sessionStorage.setItem("TabCache", JSON.stringify(this.tabList));
    if (wasSelected) {
      this.selectedTab = currentIndex;
    } else if (
      previousIndex < this.selectedTab &&
      currentIndex >= this.selectedTab
    ) {
      this.selectedTab--;
    } else if (
      previousIndex > this.selectedTab &&
      currentIndex <= this.selectedTab
    ) {
      this.selectedTab++;
    }
  }

  timer = null;
  refreshTab() {
    const loadingIcon = document.getElementById("loadingIcon");
    loadingIcon.classList.add("refresh-tab-loading");
    if (this.timer) {
      clearInterval(this.timer);
    }
    // 模拟加载过程，1秒后移除动画
    this.timer = setTimeout(() => {
      loadingIcon.classList.remove("refresh-tab-loading");
      this.timer = null;
    }, 1500);
    // this.keepAlive.clearCache(this.tabList[this.selectedTab].url);
    // this.drawer.deleteCache(this.tabList[this.selectedTab].url);
    const currentUrl = this.router.url; // 获取当前 URL
    this.onRefreshTab.emit(currentUrl);
    // this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
    //   this.router.navigateByUrl(currentUrl); // 重新导航到当前 URL
    // });
  }

  clearCache(url) {
    this.keepAlive.clearCache(this.urlWithoutQuery(url)); // 调用自定义策略的清除缓存方法
    this.drawer.deleteCache(url);
  }
  cleanAllCache() {
    sessionStorage.removeItem("TabCache"); // 清除缓存
    this.tabList = []; // 清空 tab 列表
    this.selectedTab = 0; // 重置选中的 tab 索引
    this.keepAlive.clearAllCache(); // 调用自定义策略的清除缓存方法
  }
  private urlWithoutQuery(url) {
    return url.split("?")[0];
  }
}
